"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Mode;
(function (Mode) {
    Mode[Mode["DEV"] = 0] = "DEV";
    Mode[Mode["PRODUCTION"] = 1] = "PRODUCTION";
})(Mode = exports.Mode || (exports.Mode = {}));
var getMode = function () {
    return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') ? Mode.DEV : Mode.PRODUCTION;
};
var EnvMode = (function () {
    function EnvMode() {
        this.mode = getMode();
    }
    EnvMode.prototype.get = function () {
        return this.mode;
    };
    EnvMode.prototype.isDev = function () {
        return this.mode === Mode.DEV;
    };
    EnvMode.prototype.isProd = function () {
        return this.mode === Mode.PRODUCTION;
    };
    return EnvMode;
}());
exports.EnvMode = EnvMode;
exports.currentMode = new EnvMode();
//# sourceMappingURL=Mode.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/util/Mode.js
// module id = 1447
// module chunks = 0